const PHRASES = [
    "NOT EVERY MIRROR HOLDS A SOUL",
    "SOMEWHERE, SHE IS LIVING THE LIFE THAT WAS YOURS",
    "THE MIRROR REMEMBERS WHAT YOU FORGOT",
    "TWO SISTERS — ONE SOUL — NO SEAM",
];

export const Marquee = () => (
    <div
        data-testid="editorial-marquee"
        className="relative overflow-hidden border-y border-purple-500/15 bg-[#0b031e]/60 py-5 backdrop-blur-sm"
    >
        <div className="marquee-track flex w-max items-center">
            {[...PHRASES, ...PHRASES].map((p, i) => (
                <span
                    key={i}
                    className="flex items-center whitespace-nowrap font-cormorant text-xl italic text-[#e0aaff]/50 sm:text-2xl"
                >
                    <span className="px-10">{p}</span>
                    <span className="text-[#c77dff]/40">✦</span>
                </span>
            ))}
        </div>
    </div>
);
